<!--
 * @Author: Tommy Chen weiyao_85@163.com
 * @Date: 2025-01-23 16:37:22
 * @LastEditors: Tommy Chen weiyao_85@163.com
 * @LastEditTime: 2025-06-25 22:41:38
 * @FilePath: /help.center.intl/src/views/Home.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="isp-cloud-container">
    <Cloudhome v-show="typeHome" @handleItemClick="goToArticle" @moreArticle="moreArticle"/>
    <ArticleContent v-if="!typeHome&&isArticle" :id="id"  @handleBack="handleBack" :outlinkid="outlinkid"/>
     <Mululist 
        v-show="!typeHome&&!isArticle"  @goToArticle="mulugoToArticle" @handleBack="handleBack"
      />  
  </div>
</template>

<script>
import Cloudhome from "@/views/ispcloud/cloudhome.vue";
import ArticleContent from "./ArticleContent.vue";
import Mululist from "./mululist.vue";
export default {
  name: "Home",
  components: {
    Cloudhome,
    ArticleContent,
    Mululist,
  },
  mounted() {
    if(this.$route.query.id){
      this.goToArticle({id:this.$route.query.id});
    }
    this.initMessageListener();
    // 设置 body 背景色为透明
    this.setBodyBackground();
    // 发送页面加载完成消息
    this.$nextTick(() => {
      this.checkIframeStatus();
      this.sendPageLoadedMessage();
      // 添加测试消息
      setTimeout(() => {
        this.sendTestMessage();
      }, 1000);
    });
  },
  beforeDestroy() {
    this.removeMessageListener();
    // 恢复 body 样式
    this.restoreBodyBackground();
  },
  data() {
    return {
      system: process.env.VUE_APP_SYS,
      typeHome: true,
      messageHandler: null, // 存储消息处理器引用
      receivedMessages: [], // 存储接收到的消息历史
      event:'',
      id:'',//文章对应的id
      isArticle:false,
      outlinkid:false
    };
  },
  computed: {

  },
  watch: {

    typeHome(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.sendViewChangeMessage(newVal ? 'home' : 'article', {
          from: oldVal ? 'home' : 'article',
          to: newVal ? 'home' : 'article'
        });
      }
    },
    '$route.query.id'(newId, oldId) {
      if (newId !== oldId) {
        this.sendMessageToParent('articleChanged', {
          articleId: newId,
          previousId: oldId
        });
      }
    }
  },
  methods:{
    moreArticle(){
      this.isArticle=false;
      this.typeHome=false;
  
    },
    handleBack(){
      this.outlinkid = false;
      if(this.lastType=="mulu"){
        this.isArticle=false;
        this.typeHome=false;
        this.lastType="";
      }else{
     
        this.typeHome=true;
      }
    },

    
    handleHelpGuideClose() {
      console.log('Help Guide closed');
      // 处理关闭 Help Guide 的逻辑
    },
    // 初始化消息监听器
    initMessageListener() {
      this.messageHandler = this.handleMessage.bind(this);
      window.addEventListener('message', this.messageHandler);
      console.log('ISP Cloud Home组件消息监听器已初始化');
    },

    // 移除消息监听器
    removeMessageListener() {
      if (this.messageHandler) {
        window.removeEventListener('message', this.messageHandler);
        console.log('ISP Cloud Home组件消息监听器已移除');
      }
    },

    // 处理接收到的消息
    handleMessage(event) {
      this.event=event;
      this.outlinkid = false;
      if(event.data.type=='article'){
        this.isArticle = true;
        this.typeHome=false;
        this.id=event.data.id;
        this.outlinkid = true;
      }else if(event.data.type=='home'){
        this.typeHome=true;
        this.isArticle=false;
        this.id = '';
      }
      console.log('收到消息事件:', event);
      console.log('消息来源:', event.origin);
      console.log('当前页面origin:', window.location.origin);
      console.log('消息数据:', event.data);
      
      // 验证消息来源（增加安全性）
      const allowedOrigins = [
        'http://localhost:9000',
        'http://localhost:9001', 
        'http://127.0.0.1:9000',
        'http://127.0.0.1:9001',
        'http://192.168.110.58:9000',
        'http://192.168.110.58:9001'
      ];
      
      if (!allowedOrigins.includes(event.origin)) {
        console.warn('消息来源不在允许列表中:', event.origin);
        console.log('允许的来源:', allowedOrigins);
        // 在开发环境中，我们仍然处理消息，但在生产环境中应该拒绝
        // return;
      }
      
      // 从 event.data 中获取消息内容
      const messageData = event.data;
      const { data, type, action } = messageData || {};
      
      console.log('ISP Cloud Home组件接收到父窗口消息:', data, type, action);
      
      // 记录消息历史
      this.receivedMessages.push({
        ...messageData,
        timestamp: Date.now()
      });
      
      // 根据消息类型处理不同的业务逻辑
      switch (type) {
        case 'navigation':
          this.handleNavigationMessage(data);
          break;
        case 'data':
          this.handleDataMessage(data);
          break;
        case 'action':
          this.handleActionMessage(action, data);
          break;
        case 'config':
          this.handleConfigMessage(data);
          break;
        case 'view':
          this.handleViewMessage(data);
          break;
        default:
          console.log('ISP Cloud Home组件未知消息类型:', type);
      }
    },

    // 处理导航相关消息
    handleNavigationMessage(data) {
      if (data && data.route) {
        this.$router.push(data.route);
      }
      if (data && data.path) {
        this.$router.push(data.path);
      }
      if (data && data.query) {
        this.$router.push({
          path: data.path || this.$route.path,
          query: data.query
        });
      }
    },

    // 处理数据相关消息
    handleDataMessage(data) {
      if (data && data.system) {
        this.system = data.system;
      }
      if (data && data.typeHome !== undefined) {
        this.typeHome = data.typeHome;
      }
    },

    // 处理动作相关消息
    handleActionMessage(action, data) {
      switch (action) {
        case 'refresh':
          this.refreshPage();
          break;
        case 'scrollToTop':
          window.scrollTo(0, 0);
          break;
        case 'switchView':
          this.switchView(data);
          break;
        case 'goToArticle':
          this.goToArticle(data);
          break;
        default:
          console.log('ISP Cloud Home组件未知动作:', action);
      }
    },

    // 处理配置相关消息
    handleConfigMessage(data) {
      if (data && data.system) {
        this.system = data.system;
      }
      if (data && data.theme) {
        this.applyTheme(data.theme);
      }
    },

    // 处理视图相关消息
    handleViewMessage(data) {
      if (data && data.showHome !== undefined) {
        this.typeHome = data.showHome;
      }
      if (data && data.articleId) {
        this.showArticle(data.articleId);
      }
    },

    // 刷新页面
    refreshPage() {
      window.location.reload();
    },

    // 切换视图
    switchView(data) {
      if (data && data.view) {
        this.typeHome = data.view === 'home';
      }
    },
    mulugoToArticle(data){
      this.outlinkid = false;
      this.goToArticle(data);
      this.lastType="mulu";
    },
    // 跳转到文章
    goToArticle(data) {
      this.lastType="";
    
    
      console.log(data);
      this.typeHome=false;
      this.isArticle=true;
      this.id = data.id;
      this.sendMessageToParent('article', {
        id: data.id
      });
    },
    // 应用主题
    applyTheme(theme) {
      document.body.className = theme;
      console.log('主题已应用:', theme);
    },

    // 向父窗口发送消息
    sendMessageToParent(type, data) {
      if (window.parent && window.parent !== window) {
        const message = {
          type,
          data,
          timestamp: Date.now(),
          source: 'isp-cloud-home',
          from: window.location.origin
        };
        
        // 尝试发送到父窗口
        try {
          window.parent.postMessage(message, '*'); // 开发环境使用 '*'，生产环境应该指定具体 origin
          console.log('ISP Cloud Home组件向父窗口发送消息:', message);
        } catch (error) {
          console.error('发送消息到父窗口失败:', error);
        }
      } else {
        console.warn('无法找到父窗口或当前窗口就是父窗口');
      }
    },

    // 发送页面加载完成消息
    sendPageLoadedMessage() {
      this.sendMessageToParent('pageLoaded', {
        page: 'isp-cloud-home',
        url: window.location.href,
        title: document.title,
        currentView: this.typeHome ? 'home' : 'article',
        articleId: this.$route.query.id
      });
    },

    // 发送视图切换消息
    sendViewChangeMessage(viewType, data) {
      if(!this.typeHome&&this.isArticle) {
        this.sendMessageToParent('article', {
        viewType,
      id:this.id,
        timestamp: Date.now()
      });

      } else {
        this.sendMessageToParent('viewChanged', {
        viewType,
        data,
        timestamp: Date.now()
      });
      }
      
    },

    // 发送测试消息
    sendTestMessage() {
      this.sendMessageToParent('test', {
        message: '这是来自 iframe 的测试消息',
        timestamp: Date.now()
      });
    },

    // 检查 iframe 状态
    checkIframeStatus() {
      console.log('=== iframe 状态检查 ===');
      console.log('当前页面 URL:', window.location.href);
      console.log('当前页面 origin:', window.location.origin);
      console.log('父窗口是否存在:', !!window.parent);
      console.log('父窗口是否等于当前窗口:', window.parent === window);
      
      // 安全地获取父窗口origin
      try {
        const parentOrigin = window.parent && window.parent !== window ? window.parent.location.origin : 'N/A';
        console.log('父窗口 origin:', parentOrigin);
      } catch (error) {
        console.log('无法访问父窗口 origin（跨域限制）:', error.message);
      }
      
      if (window.parent && window.parent !== window) {
        try {
          // 尝试访问父窗口的属性（可能会因为跨域而失败）
          console.log('父窗口 location:', window.parent.location.href);
        } catch (error) {
          console.log('无法访问父窗口 location（跨域限制）:', error.message);
        }
      }
    },

    // 设置 body 背景色为透明
    setBodyBackground() {
      // 直接设置 body 样式
      document.body.style.background = 'transparent';
      document.body.style.margin = '0';
      document.body.style.padding = '0';
      
      // 同时设置 html 元素
      document.documentElement.style.background = 'transparent';
      document.documentElement.style.margin = '0';
      document.documentElement.style.padding = '0';
      
      console.log('Home.vue: Body 背景色已设置为透明');
    },
    
    // 恢复 body 样式
    restoreBodyBackground() {
      // 恢复 body 样式
      document.body.style.background = '';
      document.body.style.margin = '';
      document.body.style.padding = '';
      
      // 恢复 html 元素样式
      document.documentElement.style.background = '';
      document.documentElement.style.margin = '';
      document.documentElement.style.padding = '';
      
      console.log('Home.vue: Body 样式已恢复');
    },
  }
};
</script>
<style scoped>
.backlog {
  position: fixed;
  z-index: 999;
  width: 38px;
  padding: 8px;
  height: 104px;
  background: var(--bg-dialog);
  right: 0;
  top: 50%;
  border-style: solid;
  border-color: var(--gray-4);
  /* 弹窗阴影 */
  box-shadow: 0px 2px 8px var(--shadow-1);
  border-radius: 4px 0px 0px 4px;
  font-weight: 400;
font-size: 14px;
line-height: 22px;
}

.isp-cloud-container{
  width: 100%;
 
}
::v-deep  body{
  background: transparent !important;
  margin: 0 !important;
  padding: 0 !important;
}
body{
  background: transparent !important;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
